module.exports = __webpack_public_path__ + "img/db5684476528b637e4b44b9c3de8182b.png";